import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Section from './Section.js'

function BasicTemplate(props) {
    return (
        <Section className="intro_form">
            <Row>
                <Col className="text-center" xs={12} md={12} lg={12}>
                    <img className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)} alt='logo'/>
                </Col>
                <Col className="text-center" xs={10} xsOffset={1} md={10} mdOffset={1} lg={10} lgOffset={1}>
                    {props.children}
                </Col>
            </Row>
        </Section>
        );
};
export default BasicTemplate;


/** WEBPACK FOOTER **
 ** ./src/components/BasicTemplate.js
 **/